import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";

export const wordTwDataTable = staticTable(
  "word_tw_data",
  {
    tbclLevel: integer("tbcl_level"),

    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),
  },
  // Matches every other `word_*_data` table — `wordId` backs the per-word join.
  (table) => [index("word_tw_data_word_id_idx").on(table.wordId)],
);

export type WordTwData = typeof wordTwDataTable.$inferSelect;
